import { render, staticRenderFns } from "./simple-data.vue?vue&type=template&id=2b26a002&scoped=true&"
import script from "./simple-data.vue?vue&type=script&lang=js&"
export * from "./simple-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b26a002",
  null
  
)

export default component.exports